"use client";

import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

type Props = { className?: string };

export function Spotlight({ className }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onMove = (e: MouseEvent) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty("--mx", `${e.clientX - r.left}px`);
      el.style.setProperty("--my", `${e.clientY - r.top}px`);
    };
    const parent = el.parentElement;
    if (!parent) return;
    parent.addEventListener("mousemove", onMove);
    return () => parent.removeEventListener("mousemove", onMove);
  }, []);

  return <div ref={ref} aria-hidden className={cn("spotlight absolute inset-0", className)} />;
}
